import { createAction, props } from '@ngrx/store';

export const setShowSidebar = createAction('[Core] Set showSidebar', props<{ value: boolean }>());
export const setToggleSidebar = createAction('[Core] Set toggle sidebar');
